import React from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import shortid from 'shortid'
import Section from '../../molecules/Section'
import { markdownify } from '../../../utils'
import { LinkList } from '../../atoms/Lists'
import styles from './Details.module.css'

export interface DetailsProps {
  details: {
    title: string
    description: string
    items: Detail[]
  }
}

interface DetailsLink {
  title: string
  url: string
}

interface Detail {
  title: string
  description: string
  links?: DetailsLink[]
}

export default function Details({ details }: DetailsProps) {
  const { title, description, items } = details

  return (
    <Section title={title} description={description} headerCenter>
      <Tabs className={styles.tabs}>
        <TabList className={styles.tabList}>
          {items.map((item: Detail) => (
            <Tab className={styles.tab} key={shortid.generate()}>
              <h3 className={styles.title}>{item.title}</h3>
            </Tab>
          ))}
        </TabList>
        <div className={styles.tabContent}>
          {items.map((item: Detail) => (
            <TabPanel className={styles.tabPanel} key={shortid.generate()}>
              {markdownify(item.description)}

              {item.links && <LinkList links={item.links} />}
            </TabPanel>
          ))}
        </div>
      </Tabs>
    </Section>
  )
}
